
export class ActionChangeStatus {
  public status: any;
}
